export enum OwnershipVerb {
  Have = 'have',
  Has = 'has',
}

export enum Pronoun {
  This = 'dieses',
  These = 'diese',
}
